export default {
    data: () => ({
        wallet_subject_deposit: "deposit",
        wallet_subject_withdraw: "withdraw",
        wallet_subject_pendwithdraw: "pend-withdraw",
        wallet_subject_pendwithdrawcancelled: "pend-withdraw-cancelled",
        wallet_subject_pendwithdrawconfirmed: "pend-withdraw-confirmed",

        wallet_refcode_topup: "TOPUP",
        wallet_refcode_refund: "REFUND",
        wallet_refcode_sc: "SC",
        wallet_refcode_ic: "IC",
        wallet_refcode_cod: "COD",
        wallet_refcode_vat: "VAT",
    }),

    methods: {
        transformTxTypeText(subject, ref_code, remark) {
            switch (true) {
                case [this.wallet_subject_deposit].includes(subject)
                    && ref_code === this.wallet_refcode_topup:
                    return 'เติมเงิน';
                case [this.wallet_subject_deposit].includes(subject)
                    && ref_code === this.wallet_refcode_refund
                    && remark.includes('insurance'):
                    return 'คืนเงินค่าประกัน';
                case [this.wallet_subject_deposit].includes(subject)
                    && ref_code === this.wallet_refcode_refund:
                    return 'คืนเงิน';

                case [this.wallet_subject_withdraw, this.wallet_subject_pendwithdraw, this.wallet_subject_pendwithdrawconfirmed].includes(subject)
                    && ref_code === this.wallet_refcode_sc:
                    return 'ค่าขนส่ง';
                case [this.wallet_subject_withdraw, this.wallet_subject_pendwithdraw].includes(subject)
                    && ref_code === this.wallet_refcode_ic:
                    return 'ค่าประกัน';
                case [this.wallet_subject_withdraw, this.wallet_subject_pendwithdraw].includes(subject)
                    && ref_code === this.wallet_refcode_cod:
                    return 'ค่าธรรมเนียม COD';
                case [this.wallet_subject_withdraw, this.wallet_subject_pendwithdraw].includes(subject)
                    && ref_code === this.wallet_refcode_vat:
                    return 'ค่า VAT';
                case [this.wallet_subject_withdraw, this.wallet_subject_pendwithdraw].includes(subject):
                    return 'ตัดเงิน';

                case [this.wallet_subject_pendwithdrawcancelled].includes(subject)
                    && ref_code === this.wallet_refcode_sc:
                    return 'ยกเลิกค่าขนส่ง';
                case [this.wallet_subject_pendwithdrawcancelled].includes(subject)
                    && ref_code === this.wallet_refcode_ic:
                    return 'ยกเลิกค่าประกัน';
                case [this.wallet_subject_pendwithdrawcancelled].includes(subject)
                    && ref_code === this.wallet_refcode_cod:
                    return 'ยกเลิกค่าธรรมเนียม COD';
                case [this.wallet_subject_pendwithdrawcancelled].includes(subject)
                    && ref_code === this.wallet_refcode_vat:
                    return 'ยกเลิกค่า VAT';
                case [this.wallet_subject_pendwithdrawcancelled].includes(subject):
                    return 'ยกเลิกตัดเงิน';
                default:
                    return '';
            }
        }
    },
};
